export const hasValidDates = ({ context }) => {
    if (!context.effectiveFrom || !context.effectiveTo)
        return false;
    return new Date(context.effectiveFrom) < new Date(context.effectiveTo);
};
export const hasRequiredSignatures = ({ context }) => !!context.clientSigned && !!context.tutorSigned;
export const hasTerminationReason = ({ context }) => !!context.terminationReason;
//# sourceMappingURL=tutoring-agreement.js.map